import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AutomationModule } from '@frontend/sports/automation/core-feature';
import { EffectsModule } from '@ngrx/effects';
import { RxFor } from '@rx-angular/template/for';
import { NgxPopperjsModule } from 'ngx-popperjs';
import { ShowInEpcotDirective } from 'packages/sports/web/app/src/common/epcot-config.directive';
import { MarketSubtypeLogoComponent } from 'packages/sports/web/app/src/marketsubtype-logo/marketsubtype-logo.component';

import BetslipBaseModule from '../../base/betslip-base.module';
import { LinearBetslipModule } from '../linear/linear-betslip-module';
import BetslipDigitalPicksModule from '../picks/betslip-digital-picks.module';
import PickOddsModule from '../picks/pick-odds.module';
import { DigitalRewardTokensModule } from '../reward-tokens/digital-reward-tokens.module';
import BetslipDigitalStakeModule from '../stake/betslip-digital-stake.module';
import BetslipDigitalSummaryModule from '../summary/betslip-digital-summary.module';
import BetslipDigitalValidationModule from '../validation/betslip-digital-validation.module';
import { SinglePickErrorsComponent } from './components/errors/single-pick-errors.component';
import { LinearSingleBetGeneralStakeContainerComponent } from './components/linear/general-stake-container/linear-single-bet-general-stake-container.component';
import { LinearSingleBetGeneralStakeComponent } from './components/linear/linear-single-bet-general-stake.component';
import { LinearSingleBetPickSummaryComponent } from './components/linear/linear-single-bet-pick-summary.component';
import { SingleBetLinearComponent } from './components/single-bet-linear.component';
import SingleBetPickInfoColumnComponent from './components/single-bet-pick-info-column.component';
import SingleBetPickComponent from './components/single-bet-pick.component';
import SingleBetComponent from './components/single-bet.component';
import StakeEffects from './effects/stake-effects';

@NgModule({
    imports: [
        CommonModule,
        BetslipBaseModule,
        BetslipDigitalStakeModule,
        BetslipDigitalSummaryModule,
        BetslipDigitalPicksModule,
        BetslipDigitalValidationModule,
        LinearBetslipModule,
        EffectsModule.forFeature([StakeEffects]),
        PickOddsModule,
        NgxPopperjsModule,
        AutomationModule,
        DigitalRewardTokensModule,
        RxFor,
        ShowInEpcotDirective,
        MarketSubtypeLogoComponent,
    ],
    declarations: [
        SingleBetComponent,
        SingleBetLinearComponent,
        SingleBetPickComponent,
        SingleBetPickInfoColumnComponent,
        LinearSingleBetPickSummaryComponent,
        LinearSingleBetGeneralStakeComponent,
        LinearSingleBetGeneralStakeContainerComponent,
        SinglePickErrorsComponent,
    ],
    exports: [SingleBetComponent, SingleBetLinearComponent],
})
export default class BetslipDigitalSingleBetModule {}
